import React from 'react';

import { HStack } from '@looko-design-system';
import { Box, Divider } from '@mui/material';

import NotificationBtn from '@/components/notification/NotificationBtn';
import AppBarNotificationDialog from '@/components/notification/NotificationDialog';
import { useLastMatches } from '@/hook/useLastMatches';
import { useUserAuth } from '@/state/cookieContext';

import LogoSection from '../logo';
import { AclosetChatNotification } from './AclosetChatNotification';
import { ButtonsSection } from './button';
import ProfileSection from './profile';
import { 미확인_공지_알림 } from './미확인_공지_알림';
import { 세컨솔드_미처리_알림 } from './세컨솔드_미처리_알림';

export const HEADER_HEIGHT = 56 as const;

/**
 * 헤더 구성 기본 틀.
 */
export const HeaderBase = ({ header }: { header?: React.ReactNode }) => {
  const match = useLastMatches();
  const hideSidebar = match?.handle?.hideSidebar === true;

  return (
    <Box
      component={'header'}
      sx={{
        width: '100%',
        height: HEADER_HEIGHT,
        px: 2,
        display: 'flex',
        alignItems: 'center',
        zIndex: 200,
        justifyContent: 'space-between',
      }}
    >
      <HStack>{hideSidebar && <LogoSection />}</HStack>
      {header}
    </Box>
  );
};

/**
 * 공용 레이아웃 Navbar
 */
export default React.memo(function Header() {
  const userAuth = useUserAuth();
  const isOwner = userAuth?.roles.includes('ROLE_OWNER') ?? false;

  return (
    <HeaderBase
      header={
        <HStack alignItems={'center'} spacing={2}>
          <미확인_공지_알림 />
          <세컨솔드_미처리_알림 />
          {isOwner && <AclosetChatNotification />}
          <NotificationBtn />
          <ProfileSection />
          <Box>
            <Divider orientation="vertical" sx={{ height: '28px' }} flexItem />
          </Box>
          <ButtonsSection />

          <AppBarNotificationDialog />
        </HStack>
      }
    />
  );
});
